import type { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';

export const isD2cModelVsp = (vehicle: Vehicle | null) =>
  vehicle?.eligibleProducts?.includes('ONLY_ON_HEYCAR');
